"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var ExcessesTree_1 = require("./ExcessesTree");
var LimitsTree_1 = require("./LimitsTree");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var services_1 = require("@falcon/services");
var ExtraCoversTree_1 = require("./ExtraCoversTree");
var ValuableItemTree_1 = require("./ValuableItemTree");
var TaxesTreeComponent_1 = require("./TaxesTreeComponent");
var HomeWarrantiesTree_1 = require("./HomeWarrantiesTree");
var Tree_1 = require("../../components/Tree");
var CoveragesTree = /** @class */ (function (_super) {
    __extends(CoveragesTree, _super);
    function CoveragesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCoverages = function () {
            var coverages = [];
            var isHomeProduct = services_1.productHelper.isHome(_this.props.interaction);
            for (var _i = 0, _a = _this.props.policyVersion.coverages; _i < _a.length; _i++) {
                var coverage = _a[_i];
                coverages.push((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "".concat(_this.getCoverageText(coverage), " ").concat((0, commonFunctions_1.getAmountToDisplay)(coverage.premium)), children: [coverage.coverageCode === "VALUABLE_ITEM" && ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Description: " }), _this.getValuableItemDescription(coverage)] }) })), (0, jsx_runtime_1.jsx)(ExcessesTree_1.default, { interaction: _this.props.interaction, coverage: coverage }), (0, jsx_runtime_1.jsx)(LimitsTree_1.default, { interaction: _this.props.interaction, coverage: coverage }), (0, jsx_runtime_1.jsx)(TaxesTreeComponent_1.default, { coverage: coverage })] }, coverage.coverageCode));
            }
            if (isHomeProduct) {
                coverages.push((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExtraCoversTree_1.default, { interaction: _this.props.interaction }) }, "extra-covers"));
                coverages.push((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ValuableItemTree_1.default, { interaction: _this.props.interaction }) }, "valuable-item"));
                coverages.push((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(HomeWarrantiesTree_1.default, { interaction: _this.props.interaction }) }, "warranties"));
            }
            return coverages;
        };
        _this.getCoverageText = function (coverage) {
            switch (coverage.coverageCode) {
                case "BREAKDOWN_COVER_UK":
                    return coverage.coverageText.replace("UK", "National");
                case "BREAKDOWN_COVER_EU":
                    return coverage.coverageText.replace("EU", "European");
                default:
                    return coverage.coverageText;
            }
        };
        return _this;
    }
    CoveragesTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Coverages", children: this.renderCoverages() }));
    };
    CoveragesTree.prototype.getValuableItemDescription = function (coverage) {
        var valuableItems = this.props.policyVersion.insuredValuableItems.filter(function (valuableItem) { return valuableItem.id === coverage.objectId; });
        if (valuableItems.length > 0) {
            return valuableItems[0].description;
        }
        return "";
    };
    CoveragesTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CoveragesTree);
    return CoveragesTree;
}(React.Component));
exports.default = CoveragesTree;
//# sourceMappingURL=CoveragesTree.js.map